export default "__VITE_ASSET__73d71331__"